import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from "./actions";
import { getEmployeeDocumentTypesApi } from "../../services/employee-document-type.service";
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";

export function* GET_ALL_EMPLOYEE_DOCUMENT_TYPES() {
    try {
        const response: AxiosResponse<any> = yield call(
          getEmployeeDocumentTypesApi
        );
        if (response.data) {
            yield put({
                type: actions.SET_DATA,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/employee-document-type/sagas/GET_ALL_EMPLOYEE_DOCUMENT_TYPES", e); }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DATA, GET_ALL_EMPLOYEE_DOCUMENT_TYPES),
    ])
}
